import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <polygon fillRule="evenodd" points="5.211 12 5.211 4 10.789 4 10.789 5.57 7.145 5.57 7.145 7.211 10.504 7.211 10.504 8.785 7.145 8.785 7.145 10.43 10.789 10.43 10.789 12"/>
  </svg>
);
